//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-if.js";
import { labelBanner } from "../../../../utils/WebinarDetail"
import "./BannerProduct.style";

import iconPlayWhite from "../../../../images/icons/icon_play_white.svg";

class BannerProduct extends PolymerElement {
  static get template() {
    return html`
      <style include="banner-product-style"></style>
      <div style="position: relative;">
        <img
          class="banner-webinar"
          src="[[bannerDetail]]"
          alt="webinar-banner"
        />
        <div class$="banner-label [[labelBanner(broadcastStatus)]]">[[webinarStatusText]]</div>
        <template is="dom-if" if="[[playButton]]">
          <div class="banner-play" on-click="onPlayButtonClick">
            <img src="[[iconPlayWhite]]" />
          </div>
        </template>
      </div>
    `;
  }

  static get properties() {
    return {
      bannerDetail: {
        type: String
      },
      webinarStatusText: {
        type: String
      },
      broadcastStatus: {
        type: String
      },
      labelBanner: {
        type: Function,
        value: () => labelBanner
      },
      iconPlayWhite: {
        type: String,
        value: iconPlayWhite
      },
      playButton: {
        type: Boolean,
        value: false
      }
    };
  }

  onPlayButtonClick() {
    $('#entrance-overlay').css("display", "block");
  }
}
customElements.define("banner-product", BannerProduct);
